import comp from '../components/barrel';
import Cls from '../classes/barrel';
import svg from '../js/svg';
import O from '../js/core';
import U from '../js/utils';

export default {
  async prepare() {
    this.application_uuid = thsPage.vars.application_uuid;
    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-app-summary-v2', vars));
    this.recipe.methods.push(await O.mPOST('wills/get-app-summary-docs', vars));

  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    const dataAppDets = data['application/get-app-summary-v2'].data;
    const sumDocs = data['wills/get-app-summary-docs'].data;

	
    await this.buildSumDetails(dataAppDets);
    await this.buildDocList(sumDocs);
    this.toggleWillsonlineButton(dataAppDets.willsonline_yn);
  },
  toggleWillsonlineButton(willsonlineYn) {
    if (willsonlineYn) {
      U.unhide('generateWOButton');
    } else {
      U.hide('generateWOButton');
    }
  },
  async buildSumDetails(data) {
    const {application_status} = data;

    const status_row = U.id('status_row');
    status_row.innerHTML = '';
    let statusText = await comp.statusTag(application_status);
    status_row.appendChild(statusText);

    const partyDetails_row = U.id('partyDetails_row');
    partyDetails_row.innerHTML = '';

    // Display party1 through party5
    for (let i = 1; i <= 5; i++) {
      const partyUuid = data[`party${i}`];
      const partyFName = data[`party${i}_f_name`];
      const partySName = data[`party${i}_s_name`];

      // Only display if party UUID exists and has name data
      if (partyUuid && partyFName && partySName) {
        const partyDiv = U.divAtt('div', 'id', `party${i}Div`);
        const partyLabel = U.divAtt('label', 'for', `party${i}Div`);
        partyLabel.innerHTML = `Party ${i}: `;
        const partyP = U.divAtt('p');
        partyP.innerHTML = `${partyFName} ${partySName}`;
        partyDiv.appendChild(partyLabel);
        partyDiv.appendChild(partyP);
        partyDetails_row.appendChild(partyDiv);
      }
    }
  },
  async buildDocList(data) {
    U.hide('listDiv');

    const documentListDiv = U.id('documentListDiv');
    documentListDiv.innerHTML = '';

    const table = U.divAtt('table', 'class', 'w-full');

    // HEADER
    const thead = U.divAtt('thead', 'class', 'w-full');
    const headRow = thead.insertRow();

    const h1 = headRow.insertCell(0);
    h1.innerHTML = 'Date';
    const h2 = headRow.insertCell(1);
    h2.innerHTML = 'Generated By';
    const h3 = headRow.insertCell(2);
    h3.innerHTML = 'Version';
    const h4 = headRow.insertCell(3);
    h4.innerHTML = 'Type';
    const h5 = headRow.insertCell(4);
    h5.innerHTML = 'Download';
    thead.appendChild(headRow);
    table.appendChild(thead);

    // Body
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);

    if (data.length) {
      data.forEach(async (row) => {
        const willRow = tbody.insertRow();
        const r1 = willRow.insertCell(0);
        r1.innerHTML = await U.formatDateTime(row.created_date);
        const r2 = willRow.insertCell(1);
        r2.innerHTML = `${row.f_name} ${row.s_name}`;
        const r3 = willRow.insertCell(2);
        r3.innerHTML = row.version_ref || '';
        const r4 = willRow.insertCell(3);
        const typeIcon = svg.fileTypeIcon(row.file_type);
        if (typeIcon) {
          r4.appendChild(typeIcon);
        }
        const r5 = willRow.insertCell(4);
        const download_onclick = `thsTab.downloadFile('${row.file_uuid}')`;
        const linkSVG = svg.download(download_onclick);
        r5.appendChild(linkSVG);
      });
      U.unhide('listDiv');
    }

    documentListDiv.appendChild(table);
  },
  async downloadFile(file_uuid) {
    const vars = {};
    vars.file_uuid = file_uuid;

    O.PREP([await O.mPOST('files/get-file-url', vars)])
      .then(async (res) => {
        window.open(res['files/get-file-url'].data.signedUrl, '_blank');
      })
      .catch((err) => {
      });
  },
  async generateNewDocument() {
    const vars = {};
    vars.application_uuid = this.application_uuid;

    O.PREP([await O.mPOST('wills/gen-summary-document-v2', vars)])
      .then(async () => {
        await this.render();
      })
      .catch((err) => {
      });
  },
  async generateWillsonlineDocument() {
    const vars = {};
    vars.application_uuid = this.application_uuid;

    O.PREP([new Cls.Plate('wo/gen-summary-document', vars, 'POST', process.env.VITE_API_URL_LOCAL)])
      .then(async () => {
        await this.render();
      })
      .catch((err) => {
      });
  },
};
